import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import FieldsController from '../../controllers/FieldsController';
import EditObjectField from './EditObjectField';
import AttributeTable from './attributes/AttributeTable';
import { type fabric } from 'fabric';
import { type IDataStoreRecordBehaviors } from '../../collaboration/DataStoreRecordBehaviors';

interface EditObjectFieldsProps {
  objects: Array<fabric.Object & IDataStoreRecordBehaviors>;
}

const EditObjectFields: React.FC<EditObjectFieldsProps> = ({ objects }) => {
  const controller = useController(FieldsController);
  const { fields } = controller.state;

  return (
    <AttributeTable>
      {fields.map(field => (
        <EditObjectField key={field.id} field={field} objects={objects} />
      ))}
    </AttributeTable>
  );
};

export default ApplicationView(EditObjectFields);
